// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Light pink background for females */
/* Light pink background for females */
.female-row {
  background-color: #ffc0cb;
}

.male-row {
  background-color: #add8e6;
  /* Light blue background for males */
}

.female-text {
  color: #c2185b;
  /* Darker pink text for females */
}

.male-text {
  color: #1976d2;
  /* Darker blue text for males */
}

.code-style {
  font-size: 12px;
}

.photo-prompt-image {
  width: 100px;
  /* Или другой размер, который вам подходит */
  height: auto;
  border-radius: 4px;
  padding: 0;
  min-width: 200px;
}

.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  /* Задаём количество столбцов с автоматической шириной */
  grid-gap: 0;
  /* Убираем отступы между элементами */
}

.gallery div {
  position: relative;
}

.gallery img {
  width: 100%;
  height: auto;
  display: block;
  /* Убирает небольшой отступ под картинкой */
}

.gallery p {
  position: absolute;
  width: 100%;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  /* Полупрозрачный фон для текста */
  color: white;
  /* Цвет текста */
  padding: 5px;
  /* Отступы внутри блока с текстом */
  margin: 0;
  /* Убираем отступы */
  text-align: center;
}

/* Добавляем переходы при наведении для наглядности */
.gallery div:hover img {
  opacity: 0.9;
}

.gallery div:hover p {
  background: rgba(0, 0, 0, 0.7);
}

.switch-view {
  background: #fff;
  /* Или другой цвет фона */
  padding: 10px;
  border-radius: 0 5px 5px 0;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.inactive td {
  background-color: #ccc !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/photo-prompts/photo-prompts.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,sCAAA;AAEA,sCAAA;AAEA;EACE,yBANU;AAKZ;;AAIA;EACE,yBARQ;EASR,oCAAA;AADF;;AAIA;EACE,cAAA;EACA,iCAAA;AADF;;AAIA;EACE,cAAA;EACA,+BAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,YAAA;EACA,4CAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,4DAAA;EACA,wDAAA;EACA,WAAA;EACA,qCAAA;AADF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,2CAAA;AADF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,8BAAA;EACA,kCAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,mCAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;AADF;;AAIA,qDAAA;AACA;EACE,YAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAIA;EACE,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,0CAAA;AADF;;AAKE;EACE,iCAAA;AAFJ","sourcesContent":["$female-bg: #ffc0cb;\n/* Light pink background for females */\n$male-bg: #add8e6;\n/* Light pink background for females */\n\n.female-row {\n  background-color: $female-bg;\n}\n\n.male-row {\n  background-color: $male-bg ;\n  /* Light blue background for males */\n}\n\n.female-text {\n  color: #c2185b;\n  /* Darker pink text for females */\n}\n\n.male-text {\n  color: #1976d2;\n  /* Darker blue text for males */\n}\n\n.code-style {\n  font-size: 12px;\n}\n\n.photo-prompt-image {\n  width: 100px;\n  /* Или другой размер, который вам подходит */\n  height: auto;\n  border-radius: 4px;\n  padding: 0;\n  min-width: 200px;\n}\n\n.gallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  /* Задаём количество столбцов с автоматической шириной */\n  grid-gap: 0;\n  /* Убираем отступы между элементами */\n}\n\n.gallery div {\n  position: relative;\n}\n\n.gallery img {\n  width: 100%;\n  height: auto;\n  display: block;\n  /* Убирает небольшой отступ под картинкой */\n}\n\n.gallery p {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  /* Полупрозрачный фон для текста */\n  color: white;\n  /* Цвет текста */\n  padding: 5px;\n  /* Отступы внутри блока с текстом */\n  margin: 0;\n  /* Убираем отступы */\n  text-align: center;\n}\n\n/* Добавляем переходы при наведении для наглядности */\n.gallery div:hover img {\n  opacity: 0.9;\n}\n\n.gallery div:hover p {\n  background: rgba(0, 0, 0, 0.7);\n}\n\n.switch-view {\n  background: #fff;\n  /* Или другой цвет фона */\n  padding: 10px;\n  border-radius: 0 5px 5px 0;\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.inactive {\n  td {\n    background-color: #ccc !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
